import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { Util, XmStore, XmStoreUtil } from 'core/services';
import { StateObject, StateService } from '@uirouter/core';
import { CmsAddonPlans } from 'store/cms/models';
import { Addon } from 'store/addons';
import { AddonAction, AddonType, ProgressStatus } from 'my-account/constants';
import { AccountSummary, LineSummary } from 'store/account-summary/models';
import { AddonLines } from 'my-account/interface';
import { AddRemoveAddons } from 'store/global-travel-pass/models';
import { StoreAction } from 'store/actions';
import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';

@Component({
    selector: 'xm-addon-result',
    templateUrl: './addon-result.html',
    styleUrls: ['./addon-result.scss'],
    standalone: false
})

export class XmAddonResult implements OnInit, OnDestroy {

    public planData: CmsAddonPlan;
    public summaryPageData: CmsAddonSummaryData;
    public loaderData: CmsLoaderContent;
    public addonData: Addon;
    public headerLinkParams: object;
    public imagePrimary: MediaImageOptions;
    public features: ReviewFeatures[] = [];
    public imageIconTimeInfo: MediaImageOptions;
    public lines: LineSummary[];
    public gtpSupportLinks: CmsGtpSupportLink[];
    public mexCanSupportLinks: string[];
    public isGTP: boolean = false;
    public isMexCan: boolean = false;
    public intent: string;
    public addonLines: AddonLines = {};
    public postAddRemovedAddonsPromise: Promise<void | StateObject>;
    public requestId: string;
    public hasApiError: boolean;
    public overallStatus: string;
    public pollingPercentage: number;
    public primaryBtnLabel: string;
    public ProgressStatus: typeof ProgressStatus = ProgressStatus;

    private addonType: string;
    private xmStore: XmStore;
    private state: StateService;
    private subscriptions: Subscription[] = [];
    private addonsUtil: AddonsUtil;

    constructor(xmStore: XmStore, state: StateService, addonsUtil: AddonsUtil) {
        Object.assign(this, { xmStore, state, addonsUtil });
    }

    public ngOnInit(): void {
        this.intent = this.addonsUtil.addonAction;
        this.addonType = this.addonsUtil.addonType;
        this.addonLines = this.addonsUtil.addonLines;

        this.subscriptions.push(this.addonsUtil.addonsPollingPercentage$.subscribe((percentage: number) => {
            this.pollingPercentage = percentage;
        }));

        if (this.addonType === AddonType.GTP) {
            this.isGTP = true;
            this.isMexCan = false;
        } else if (this.addonType === AddonType.CAN_MEX_UNL_PASS) {
            this.isGTP = false;
            this.isMexCan = true;
        }

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsAddonPlans>(CmsAddonPlans), (result: CmsAddonPlans) => {
            this.planData = result.plans.find((plan: CmsAddonPlan) => plan.gtp1B && plan.type === this.addonType);
            this.summaryPageData = this.planData.content.summaryData;
            this.primaryBtnLabel = this.intent === AddonAction.add ? this.summaryPageData.primaryBtnLabel : this.summaryPageData.confirmBtnLabel;
            if (this.intent === AddonAction.add) {
                this.loaderData = this.planData.content.loaderData.add.inProgress;
            } else if (this.intent === AddonAction.remove) {
                this.loaderData = this.planData.content.loaderData.remove.inProgress;
            }
            this.subscriptions.push(this.addonsUtil.addonsPollingStatus$.subscribe((status: string) => {
                if (status) {
                    this.overallStatus = status;
                    if (this.intent === AddonAction.add) {
                        if (this.overallStatus === ProgressStatus.SUCCESS) {
                            this.loaderData = this.planData.content.loaderData.add.success;
                        } else if (this.overallStatus === ProgressStatus.PENDING) {
                            this.loaderData = this.planData.content.loaderData.add.pending;
                        } else {
                            this.loaderData = this.planData.content.loaderData.add.inProgress;
                        }
                    } else if (this.intent === AddonAction.remove) {
                        if (this.overallStatus === ProgressStatus.SUCCESS) {
                            this.loaderData = this.planData.content.loaderData.remove.success;
                        } else if (this.overallStatus === ProgressStatus.PENDING) {
                            this.loaderData = this.planData.content.loaderData.remove.pending;
                        } else {
                            this.loaderData = this.planData.content.loaderData.remove.inProgress;
                        }
                    }
                }
            }));

        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (accountSummary: AccountSummary) => {
            this.lines = accountSummary.getLinesWithPlans;
        }));
    }

    public onCancel(): void {
        this.state.go(this.summaryPageData.secondaryLinkUiSref, this.state.params);
    }

    public onClickPrimary(): void {
        this.postAddRemovedAddonsPromise = this.xmStore.persist(StoreAction.POST_ADD_REMOVE_ADDONS, {
            payload: this.addonsUtil.postAddOnsPayload
        }).then((addRemovedResponse: AddRemoveAddons) => {
            if (addRemovedResponse.requestId) {
                this.requestId = addRemovedResponse.requestId;
                this.addonsUtil.pollingRequestId = this.requestId;
                this.state.go(this.summaryPageData.primaryBtnUiSref, this.state.params);
            } else {
                this.hasApiError = true;
            }
        }).catch(() => {
            this.hasApiError = true;
        });
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
